














































import { Vue, Component, Prop, Lifecycle, p } from "av-ts";
@Component()
export default class Rating extends Vue {
    // Max number of starts
    @Prop max = p<number>({
        required: true
    });

    @Prop disabled = p<boolean>({
        required: false,
        default: false
    });

    @Prop icon = p<string>({
        default: "star"
    });

    @Prop defaultIndex = p<number>({
        required: false,
        default: -1
    });

    // Current start selection
    selectedIndex = -1;
    previewIndex = -1;

    @Lifecycle
    created() {
        this.selectedIndex = this.defaultIndex;
        this.previewIndex = this.defaultIndex;
    }

    changeRating(e: MouseEvent) {
        if (this.disabled) {
            return;
        }

        // Check if the user clicked on child. If so, select the parent button
        let target = e.target as HTMLElement;
        if (target.tagName == "I") {
            target = target.parentElement!;
        }

        const icons = this.$refs["icons"] as Array<Vue>;
        this.selectedIndex = icons.findIndex((x: Vue) => x.$el == target);
        this.$emit("input", this.selectedIndex + 1);
    }

    previewRating(e: MouseEvent) {
        if (this.disabled) {
            return;
        }

        // Check if the user clicked on child. If so, select the parent button
        let target = e.target as HTMLElement;
        if (target.tagName == "I") {
            target = target.parentElement!;
        }
        const icons = this.$refs["icons"] as Array<Vue>;
        this.previewIndex = icons.findIndex((x: Vue) => x.$el == target);
    }

    mouseOut(_e: MouseEvent) {
        if (this.disabled) {
            return;
        }

        this.previewIndex = this.selectedIndex;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/Rating.vue